module.exports = __webpack_public_path__ + "static/media/fr-h.2c3ecb76.svg";